import React, { useEffect, useState } from 'react'
import { Col, Form, FormInstance, Input, Row } from 'antd'
import { useFindAdminByEmail } from 'api/Admin'
import { myStore } from 'state/store'
import { failureMessage } from 'api/global'
import { adminSettingStore } from 'state/setting/admin'

interface FindEmailProps {
  form: FormInstance
}

const FindEmail: React.FC<FindEmailProps> = ({ form }) => {
  const [params, setParams] = useState<{ email: string }>({
    email: '',
  })
  const [errorEmail, setErrorEmail] = useState<string>()
  const { isLoading, data } = useFindAdminByEmail(params)
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const {
    setNewEmail,
    setMailNotFoundModal,
    setAddAdminModal,
    setAdminData,
    setMailFoundModal,
  } = adminSettingStore(store => ({
    setNewEmail: store.setNewEmail,
    setMailNotFoundModal: store.setMailNotFoundModal,
    setAddAdminModal: store.setAddAdminModal,
    setAdminData: store.setAdminData,
    setMailFoundModal: store.setMailFoundModal,
  }))

  const onFinish = (values: { email: string }) => {
    setParams({
      email: values.email,
    })
  }

  useEffect(() => {
    if (!data) return
    if (data.type === 'self') {
      setErrorEmail(params.email)
      return failureMessage(data.message)
    }
    if (data.type === 'not-found') {
      setErrorEmail(undefined)
      setNewEmail(params.email)
      setMailNotFoundModal(true)
      setAddAdminModal(false)
      return
    }
    if (data.type === 'member-found') {
      setErrorEmail(undefined)
      setAdminData(data.member)
      setMailFoundModal(true)
      setAddAdminModal(false)
      return
    }
  }, [data])

  useEffect(() => {
    setModalBtnLoader(isLoading)
  }, [isLoading])

  return (
    <div className="mt-20px">
      <Form
        name="find-adult-email"
        form={form}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
      >
        <Row>
          <Col span={24}>
            <label htmlFor="" className="input-label required-input">
              Email
            </label>
            <Form.Item
              colon={false}
              name="email"
              className="form-control"
              rules={[
                {
                  required: true,
                  message: 'Email is required',
                },
                { type: 'email', message: 'Email format is not right' },
              ]}
              validateStatus={errorEmail === params.email ? 'error' : ''}
              help={
                errorEmail === params.email
                  ? 'This account is already an admin'
                  : ''
              }
            >
              <Input
                placeholder="example@gmail.com"
                className="form-control-field"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default FindEmail
